import http from "../../http-common";

class ProductRightSideBooksService {
    getProductRightSideBooksService(productPath: string) {
        return http.get(`/right-side-section/products/books/${productPath}`);
    }
}

export default new ProductRightSideBooksService();
